import i18next from 'i18next';
import { z } from 'zod';

export const requestedAppUpdateSchema = z.object({
  id: z.string().optional(),
  buildNumber: z
    .union([z.string(), z.number()])
    .transform((val) => parseInt(val as string, 10))
    .superRefine((data, ctx) => {
      if (!data) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: i18next.t('requestedAppUpdate:appBuildNumberRequired'),
        });
      }
    }),
  forceAndroidUpdate: z.boolean().default(false),
  forceIOSUpdate: z.boolean().default(false),
});

export type TRequestedAppUpdateSchema = z.infer<
  typeof requestedAppUpdateSchema
>;
